/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'list': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M21 75v6h74v-6zM5 75v6h6v-6zm16-28v6h74v-6zM5 47v6h6v-6zm16-28v6h74v-6zM5 19v6h6v-6z" fill-rule="evenodd"/>'
  }
})
